import { Loader } from "@googlemaps/js-api-loader";

let loaderPromise = null;

export async function loadMaps() {
  if (window.google?.maps?.places) return window.google;

  if (!loaderPromise) {
    const apiKey = (process.env.REACT_APP_MAPS_API_KEY || "").trim();
    if (!apiKey) throw new Error("Missing REACT_APP_MAPS_API_KEY");

    console.log("[maps] using key =", apiKey.slice(0, 8) + "…");

    const loader = new Loader({
      apiKey,
      version: "weekly",
      libraries: ["places"],
      id: "gmaps-loader",
      mapIds: (process.env.REACT_APP_MAP_ID || "").trim()
        ? [process.env.REACT_APP_MAP_ID.trim()]
        : undefined,
    });
    loaderPromise = loader.load();
  }

  await loaderPromise;
  return window.google;
}